import { lazy, Suspense } from "react";
import { Routes, Route } from "react-router";
import * as Sentry from "@sentry/react";
import { isComingSoon, isUnderConstruction } from "./lib/siteMode";
import PageLayout from "./components/layout/PageLayout";
import EditorShell from "./components/dev/EditorShell";
import ErrorFallback from "./components/ui/ErrorFallback";
import HomePage from "./pages/HomePage";
import RetreatsPage from "./pages/RetreatsPage";
import YourHostPage from "./pages/YourHostPage";
// import GalleryPage from "./pages/GalleryPage";
// import GalleryProjectPage from "./pages/GalleryProjectPage";
import ContactPage from "./pages/ContactPage";
import RetreatPage from "./pages/RetreatPage";
import ReservationPage from "./pages/ReservationPage";
import NotFoundPage from "./pages/NotFoundPage";
import UnsubscribePage from "./pages/UnsubscribePage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import FormattingTestPage from "./pages/FormattingTestPage";
import ComingSoonPage from "./pages/ComingSoonPage";
import UnderConstructionPage from "./pages/UnderConstructionPage";

const DevHubPage = lazy(() => import("./dev/DevHubPage"));
const EmailPreviewPage = lazy(() => import("./emails/preview/EmailPreviewPage"));
const SiteContentPage = lazy(() => import("./dev/SiteContentPage"));

export default function App() {
  return (
    <Sentry.ErrorBoundary fallback={<EditorShell><ErrorFallback /></EditorShell>}>
    <Routes>
      {import.meta.env.DEV && (
        <>
          <Route
            path="dev"
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <DevHubPage />
              </Suspense>
            }
          />
          <Route
            path="dev/site-content"
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <SiteContentPage />
              </Suspense>
            }
          />
          <Route
            path="dev/emails"
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <EmailPreviewPage />
              </Suspense>
            }
          />
          <Route
            path="dev/emails/:templateId"
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <EmailPreviewPage />
              </Suspense>
            }
          />
        </>
      )}
      {/* Routes that must work regardless of site mode */}
      <Route path="unsubscribe" element={<UnsubscribePage />} />
      <Route path="privacy-policy" element={<PrivacyPolicyPage />} />
      {isComingSoon ? (
        <Route path="*" element={<EditorShell><ComingSoonPage /></EditorShell>} />
      ) : isUnderConstruction ? (
        <Route path="*" element={<EditorShell><UnderConstructionPage /></EditorShell>} />
      ) : (
        <Route element={<PageLayout />}>
          <Route index element={<HomePage />} />
          <Route path="retreats" element={<RetreatsPage />} />
          <Route path="retreats/:retreatSlug" element={<RetreatPage />} />
          <Route path="retreats/:retreatSlug/reserve" element={<ReservationPage />} />
          <Route path="your-host" element={<YourHostPage />} />
          {/* Gallery hidden for now */}
          {/* <Route path="gallery" element={<GalleryPage />} /> */}
          {/* <Route path="gallery/:projectSlug" element={<GalleryProjectPage />} /> */}
          <Route path="contact" element={<ContactPage />} />
          <Route path="formatting-test" element={<FormattingTestPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      )}
    </Routes>
    </Sentry.ErrorBoundary>
  );
}
